import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { LayoutPageStickyContainer } from "../Layout/LayoutPageStickyContainer.js";
import { useTitleThemeScheme, useThemeScheme } from "../Layout/ThemeSchemeContext.js";
import { Heading } from "../Typography/Heading.js";
import { ButtonList } from "../Forms/Button/ButtonList.js";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
import { toThemeClass } from "../../utils/toThemeClass.js";
import { toSchemeClass } from "../../utils/toSchemeClass.js";
const TitleBar = memo(({ after, navigation, children, headingProps, actions, ...props }) => {
  const prefix = useClassNamePrefix();
  const {
    scheme,
    theme,
    themeContent,
    themeControls
  } = useTitleThemeScheme(props);
  const { scheme: layoutScheme } = useThemeScheme({});
  return /* @__PURE__ */ jsxs(
    LayoutPageStickyContainer,
    {
      top: 0,
      className: classNames(
        `${prefix}titleBar`,
        toThemeClass(themeContent ?? theme, themeControls ?? theme),
        toSchemeClass(scheme),
        scheme !== layoutScheme ? "is-global-theme" : void 0
      ),
      children: [
        navigation && /* @__PURE__ */ jsx("nav", { className: `${prefix}titleBar-navigation`, children: /* @__PURE__ */ jsx(ButtonList, { children: navigation }) }),
        /* @__PURE__ */ jsxs("div", { className: `${prefix}titleBar-in`, children: [
          /* @__PURE__ */ jsx("div", { className: `${prefix}titleBar-heading`, children: /* @__PURE__ */ jsx(Heading, { ...{ depth: 2, ...headingProps }, children }) }),
          actions && /* @__PURE__ */ jsx("div", { className: `${prefix}titleBar-actions`, children: /* @__PURE__ */ jsx(ButtonList, { children: actions }) })
        ] }),
        after && /* @__PURE__ */ jsx("div", { className: `${prefix}titleBar-after`, children: after })
      ]
    }
  );
});
TitleBar.displayName = "TitleBar";
export {
  TitleBar
};
//# sourceMappingURL=TitleBar.js.map
